<template>
  <div class="childRank">
    <el-form v-if="[1, 2].includes(userinfo.userLevel * 1) && [1, 2].includes(userinfo.level * 1)" :inline="true" class="my-form-template" label-width="80px">
      <el-form-item label="团队名称" class="item">
        <el-select v-model="mechanId" clearable filterable>
          <el-option :label="dept.shortName" :value="dept.id" v-for="(dept, index) in selectList" :key="index"></el-option>
        </el-select>
      </el-form-item>
      <el-button class="cxbt org-btn" type="primary" @click="querySubRank">查询</el-button>
    </el-form>
    <div class="header">
      <div class="desc">统计本机构直属及下级团队所有员工已过犹豫期(含续期)保单业绩</div>
    </div>
    <div class="contentTable">
      <el-table :data="tableData" v-loading="listLoading" border class="list-table" tooltip-effect="dark">
        <emptyBox slot="empty"></emptyBox>
        <el-table-column type="index"></el-table-column>
        <el-table-column prop="name" label="员工姓名" min-width="120" show-overflow-tooltip> </el-table-column>
        <el-table-column prop="mobile" label="电话" min-width="120" show-overflow-tooltip> </el-table-column>
        <el-table-column prop="createTime" label="入驻时间" min-width="120" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.createTime | timeSubstr(0, 10) }}
          </template>
        </el-table-column>
        <el-table-column prop="customNum" label="客户数（人）" min-width="120" show-overflow-tooltip> </el-table-column>
        <el-table-column prop="policyNum" label="出单数" min-width="100" show-overflow-tooltip> </el-table-column>
        <el-table-column prop="totleFee" label="总保费（元）" min-width="120" show-overflow-tooltip> </el-table-column>
        <el-table-column label="操作" min-width="120" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" @click="goDetail(scope.row)">查看详情</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>
<script>
//当前实例组件

import { common } from "@/api/mixins";
export default {
  mixins: [common],
  data: () => ({
    selectList: [],
    listLoading: true,
    tableData: [],
    userinfo: {},
    mechanId: '', // 部门id
  }),
  components: {},
  created() {
    this.querySubRank();
    const data = this.$tools.getLocal('userinfo');
    this.userinfo = data;
    if (data.level == 1 || (data.level == 2 && data.userLevel == 2)) {
      this.getChildList()
    }
  },
  methods: {
    // 获取团队/员工列表
    getChildList() {
      this.$http({
        url: '/master/mechan/queryChildList',
        type: 'PUT',
        params: {},
      }).then(res => {
        if (res.httpCode == 200) {
          this.selectList = res.data
        }
      }).catch(e => { })
    },
    querySubRank() {
      this.listLoading = true;
      this.$http({
        url: "/master/subAccount/querySubRank",
        type: "put",
        params: {
          mechanId: this.mechanId
        }
      }).then((data) => {
        this.listLoading = false;
        this.tableData = data.data;
      });
    },
    // 处理为空的children，el-cascader为空的数组会展示暂无数据
    handleDeptTree(data) {
      let val = data.map(item => {
        if (item.children.length == 0) {
          item.children = ''
        } else {
          this.handleDeptTree(item.children)
        }
        return item
      })
      return val
    },
    goDetail(row) {
      this.$router.push({
        path: "/childAchiev",
        query: {
          id: row.id,
          mobile: row.mobile,
          name: row.name
        }
      });
    }
  },
  mounted() { }
};
</script>
<style lang="scss">
.childRank {
  background: #fff;
  min-height: 800px;
  .header {
    i {
      display: inline-block;
      width: 5px;
      height: 16px;
      vertical-align: middle;
      background: #ff9700;
    }
    span {
      font-size: 16px;
      vertical-align: middle;
      margin-left: 10px;
    }
    .desc {
      color: red;
      font-size: 14px;
    }
  }
  .contentTable {
    margin-top: 10px;
  }
}
</style>
<style lang="scss" scoped>
.my-form-template {
  margin-bottom: 0;
  &::v-deep {
    .el-form-item {
      .el-form-item__content {
        .el-cascader {
          line-height: 32px;
        }
      }
    }
  }
}
</style>
